import { FC } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import { isResponsive } from '../../../../preview';

import { formatDate } from './utils';
import { Image, SaleTypeLogo } from './styled';
import { Props } from './types';
import { PLATFORM_TO_LOGO } from './constants';

const Lot: FC<Props> = ({
  carModel,
  carName,
  imgUrl,
  lotNumber,
  mileage,
  registrationDate,
  gearboxType,
  energyType,
  sale,
  salePrice,
}) => {
  const isHsSale =
    sale !== null && /(?:^|_)hs(?:$|_)/i.test(`${sale.id}_${sale.saleId}`);
  const lotMeta = [gearboxType, energyType, formatDate(registrationDate)]
    .filter(Boolean)
    .join(', ');
  const lotDetails = [
    mileage !== null ? `${mileage} ${'\u043a\u043c'}` : null,
    `${'\u043d\u043e\u043c\u0435\u0440 \u043b\u043e\u0442\u0430'}: ${lotNumber}`,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <Box className="lot-card">
      <Stack className="lot-row" direction="row" gap={4} justifyContent="space-between">
        <Stack className="lot-description" direction="row" gap={1}>
          <Box className="lot-image" width="150px" borderRadius={5}>
            {isResponsive && !imgUrl ? <Box className="lot-placeholder" aria-label="Нет фотографии"><DirectionsCarOutlinedIcon fontSize="large" /></Box> :
            <Image src={imgUrl || ''} alt={carName} height="115px" width="150px" />
            }
          </Box>

          <Stack className="lot-info" width="400px">
            <Typography variant="body1">{carName}</Typography>
            <Typography variant="body2">{carModel}</Typography>
            <Typography variant="caption">{lotMeta}</Typography>
            <Typography variant="caption">
              {lotDetails}
              {isHsSale && (
                <Box component="span" ml={0.5} color="error.main" fontWeight={700}>
                  HS
                </Box>
              )}
            </Typography>
          </Stack>
        </Stack>

        <Typography className="lot-price" color="primary" fontSize="18px" fontWeight="500">
          {'\u20AC'}
          {salePrice.toFixed(2)}
        </Typography>

        <Stack className="lot-auction" alignItems="flex-end">
          {sale !== null && (
            <Stack gap={0.7} alignItems="flex-end">
              <SaleTypeLogo className="lot-sale-logo" src={PLATFORM_TO_LOGO[sale.type]} alt={sale.type} />

              <Stack className="lot-sale-date" direction="row" alignItems="center" gap={0.25}>
                <Typography variant="body2">{formatDate(sale.date)}</Typography>
                <EventIcon color="primary" />
              </Stack>

              <Stack className="lot-sale-city" direction="row" alignItems="center" gap={0.25}>
                <Typography variant="body2" title={sale.locationName}>{sale.locationName}</Typography>
                <LocationOnIcon color="primary" />
              </Stack>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export { Lot };
